import { Pipe, PipeTransform } from '@angular/core';
import { convertToTzDate } from '@sa-utils/date';

@Pipe({
  name: 'tz',
  pure: false,
})
export class TzPipe implements PipeTransform {
  transform(
    value: Date | string | number,
    format: string,
    type: 'number' | 'dateString' | 'date' = 'date',
    tz?: string
  ): string {
    return convertToTzDate(value || new Date(), format, type, tz);
  }
}
